export enum toastStyles {
	successColor = '#bfd835',
	errorColor = '#324de4',
}
export enum toastTypes {
	Add = 'add',
	Update = 'update',
	delete = 'delete',
}
